export default __webpack_public_path__ + "static/media/area-22.efe03c58.jpg";